export default __webpack_public_path__ + "static/media/resting.42e0a44d.svg";